export default {
  name: 're-group-box',
  data() {
    return {}
  }
}
